module.exports = __webpack_public_path__ + "static/assets/82aa0eba517b9756a9db4e3a9144723e.svg";